<template>
    <div class="financial-details">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="320px" :validate-on-rule-change="false" class="financial-details-ruleForm">
          
            <el-form-item label="Employment Status :" prop="employment_status">
                <el-select v-model="ruleForm.employment_status" placeholder="Please Select" style="width:230px;">
                    <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.employment_status"></el-option>
                </el-select>
            </el-form-item>

             <el-form-item  label="Other :" prop="employment_status_desc" v-if="ruleForm.employment_status==='Other'">
                <el-input style="width:230px;" v-model="ruleForm.employment_status_desc"></el-input>
            </el-form-item>

            <el-form-item label="Level of Education :" prop="education_level">
                <el-select v-model="ruleForm.education_level" placeholder="Please Select" style="width:230px;">
                    <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.education_level"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Current Annual Income :" prop="current_year_income">
                <el-select v-model="ruleForm.current_year_income" placeholder="Please Select" style="width:230px;">
                    <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.current_year_income"></el-option>
                </el-select>
            </el-form-item>

             <el-form-item label="Current Liquid Assets / Savings :" prop="current_liquid_asset">
                <el-select v-model="ruleForm.current_liquid_asset" placeholder="Please Select" style="width:230px;">
                    <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.current_liquid_asset"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Source of Funds :" prop="fund_source">
                <el-select v-model="ruleForm.fund_source" placeholder="Please Select" style="width:230px;">
                    <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.fund_source"></el-option>
                </el-select>
            </el-form-item>

             <el-form-item  label="Other :" prop="fund_source_desc" v-if="ruleForm.fund_source==='Other (Please State)'">
                <el-input v-model="ruleForm.fund_source_desc" style="width:230px;"></el-input>
            </el-form-item>

            <el-form-item label="Investment Objectives :" prop="investment_goal">
                <el-select v-model="ruleForm.investment_goal" placeholder="Please Select" style="width:230px;">
                    <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.investment_goal"></el-option>
                </el-select>
            </el-form-item>

             <el-form-item  label="Other :" prop="investment_goal_desc" v-if="ruleForm.investment_goal==='Other (Please State)'">
                <el-input v-model="ruleForm.investment_goal_desc" style="width:230px;"></el-input>
            </el-form-item>

            <el-form-item label="Amount of Risk Capital Available for Trading :" prop="risk_amount">
                <el-select v-model="ruleForm.risk_amount" placeholder="Please Select" style="width:230px;">
                     <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.risk_amount"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="" prop="agreement_beneficial_owner" style="margin-left:-100px;" class="checkbox-reset">
                  <el-checkbox v-model="ruleForm.agreement_beneficial_owner" label="I confirm that I am the beneficial owner of the funds I deposit." name="type"></el-checkbox>
            </el-form-item>

            <el-form-item label="" prop="agreement_trade_risk" style="margin-left:-100px;"  class="checkbox-reset">
                  <el-checkbox v-model="ruleForm.agreement_trade_risk" label="I confirm I understand that only risk capital should be used for trading." name="type"></el-checkbox>               
            </el-form-item>

             <el-form-item style="margin-left:-100px;">
                <el-button @click="resetForm('ruleForm')" class="box-btn-default" style="width: 211px;">BACK</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="btn_loading" class="box-btn"  style="width: 221px;">NEXT</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import * as server from '../action'

export default {
  data() {
    return {
      fieldOptions: {},
      ruleForm: {
        employment_status: '',
        employment_status_desc: '',
        education_level: '',
        current_year_income: '',
        current_liquid_asset: '',
        fund_source: '',
        fund_source_desc: '',
        investment_goal: '',
        investment_goal_desc: '',
        risk_amount: '',
        agreement_beneficial_owner: '',
        agreement_trade_risk: ''
      },
      rules: {
        employment_status: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        employment_status_desc: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        education_level: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        current_year_income: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        current_liquid_asset: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        fund_source: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        fund_source_desc: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        investment_goal: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        investment_goal_desc: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        risk_amount: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        agreement_beneficial_owner: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        agreement_trade_risk: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ]
      },
      btn_loading: false
    }
  },
  created() {
    server.certification_apply_index({ step: 3 }).then(res => {
      /* get option val */
      this.fieldOptions = res.fieldOptions
      /* set default val */
      Object.keys(this.ruleForm).map((val, key) => {
        if (
          val === 'agreement_beneficial_owner' ||
          val === 'agreement_trade_risk'
        ) {
          this.ruleForm[val] = !!res.setting[val] || ''
        } else {
          this.ruleForm[val] = res.setting[val] || ''
        }
      })
    })
  },
  methods: {
    submitForm(formName) {
      this.btn_loading = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            ...this.ruleForm,
            agreement_beneficial_owner: Number(
              this.ruleForm.agreement_beneficial_owner
            ),
            agreement_trade_risk: Number(this.ruleForm.agreement_trade_risk),
            step: 3
          }
          server
            .certification_apply_save(params, true)
            .then(res => {
              if (res.data.status === 'refuse') {
                this.$alert(
                  `Unfortunately, based on the information submitted by you, we are unable to 
                  proceed with your application. If you believe there were errors in 
                  the information provided, you can go back and change them and submit again. Upon rejection from us, 
                  should there be any change in your own circumstances, please feel free to contact us again. `,
                  'Rejection Message',
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'OK',
                    center: true
                  }
                )
              } else if (res.data.status === 'warning') {
                this.$confirm(
                  'Your financial condition score appears to be low, however please confirm if you wish to continue.',
                  'WARNING',
                  {
                    confirmButtonText: 'YES',
                    cancelButtonText: 'NO',
                    type: 'warning',
                    center: true
                  }
                )
                  .then(() => {
                    let params2 = {
                      ...this.ruleForm,
                      agreement_beneficial_owner: Number(
                        this.ruleForm.agreement_beneficial_owner
                      ),
                      agreement_trade_risk: Number(
                        this.ruleForm.agreement_trade_risk
                      ),
                      step: 3,
                      ignore_warning: 1
                    }
                    server.certification_apply_save(params2).then(() => {
                      this.$emit('onStopIndex', 4)
                    })
                  })
                  .catch(() => {})
              } else if (res.code === 200) {
                this.$emit('onStopIndex', 4)
              } else if (res.code !== 200) {
                this.$message({
                  message: res.message,
                  type: 'warning'
                })
              }
              this.btn_loading = false
            })
            .catch(err => {
              this.btn_loading = false
            })
        } else {
          this.btn_loading = false
          return false
        }
      })
    },
    resetForm(formName) {
      this.$emit('onStopIndex', 2)
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.financial-details {
  .financial-details-ruleForm {
    width: 700px;
    margin: 0 auto;
  }
  .checkbox-reset {
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #0A95FF;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #0A95FF;
      border-color: #0A95FF;
    }
  }
}
</style>
